import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { TokensState } from './types';

export const getters: GetterTree<TokensState, RootState> = {
  //
};
